"use client"

import { Spinner } from "@medusajs/icons"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import styles from "./cart-empty.module.css"

export default function CartEmpty({
  hidden = false,
  state,
  error,
  onRetry,
  onContinue,
  loadingText = "Sepet yükleniyor…",
}: {
  hidden?: boolean
  state: "empty" | "loading" | "error"
  error?: string | null
  onRetry: () => void | Promise<void>
  onContinue?: () => void
  loadingText?: string
}) {
  if (state === "loading") {
    return (
      <div className={styles.root} data-testid="cart-empty" role="status">
        <Spinner aria-hidden="true" />
        <p className={styles.stateText}>{loadingText}</p>
      </div>
    )
  }

  if (state === "error") {
    return (
      <div className={styles.root} data-testid="cart-empty" role="alert">
        <p className={styles.stateText}>
          {error ?? "Sepet yüklenemedi. Lütfen tekrar deneyin."}
        </p>
        <button className={styles.retry} type="button" onClick={() => void onRetry()}>
          Tekrar dene
        </button>
      </div>
    )
  }

  return (
    <div className={styles.root} data-testid="cart-empty" hidden={hidden}>
      <h3 className={styles.message}>Sepetin şu an boş</h3>
      <p className={styles.supporting}>Favori bakım ürünlerini keşfetmeye başlayabilirsin.</p>
      <LocalizedClientLink
        href="/store"
        className={styles.continueLink}
        onClick={onContinue}
      >
        Ürünleri keşfet
      </LocalizedClientLink>
    </div>
  )
}
